import { useGameStore } from '../state/useGameStore';
import type { ClientChatMsg } from '../shared/protocol';

export function buildSendChat(sendMessage: (msg: unknown) => void) {
  return (text: string, team: 'all' | 'team' = 'all') => {
    if (!text.trim()) return;
    const msg: ClientChatMsg = { type: 'chat', text: text.trim().slice(0, 120), team };
    sendMessage(msg);
  };
}

export function useChat(sendMessage: (msg: unknown) => void) {
  const chatOpen = useGameStore((s) => s.chatOpen);
  const setChatOpen = useGameStore((s) => s.setChatOpen);
  const addChatMessage = useGameStore((s) => s.addChatMessage);

  const sendChat = buildSendChat(sendMessage);

  return { chatOpen, setChatOpen, addChatMessage, sendChat };
}
